import React, { useState, useEffect, useContext } from 'react';



import { FcKindle } from "react-icons/fc";

import Loader from '../../../components/loader/loader';
import { numberFormatter, totalFormatter, decimalFormatter } from '../../../components/formatters/numberFormatter';
import { dateFormatter } from '../../../dynamic/dateFormatter';
import { typeFormatter, paymentTypeFormatter } from '../../../components/formatters/defFormatter';
import { dateTableFormatter } from '../../../dynamic/dateFormatter';
import toast from 'react-hot-toast';
import { FiRotateCcw } from "react-icons/fi";
import { Space, Input, Switch, Button, Spin, Modal, Card, Tabs } from 'antd';

import Select from 'react-select';
import AsyncSelect from 'react-select/async';

import { Col, Form, Row, DropdownButton, Dropdown, InputGroup } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../../init/getData';




function Loayalty(props) {

  let { type, isDebit } = props;

  const { api, userData, currencyData, settingData, companyId, refData, yearId, contentLanguages } = useContext(DataContext);
  const userRole = userData.role;
  const [loadingCounter, setLoadingCounter] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingEffect, setLoadingEffect] = useState(false);
  const [isSpinning, setIsSpinning] = useState(false);
  const [setting, setSetting] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataArray = ['setting']
        await refData(dataArray, companyId);
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);


  useEffect(() => {
    setSetting({
      pointToCurrency: settingData.pointToCurrency,
      
      normalCustomer: settingData.normalCustomer,
      bronzeCustomer: settingData.bronzeCustomer,
      silverCustomer: settingData.silverCustomer,
      goldCustomer: settingData.goldCustomer,
      
      normalPoint: settingData.normalPoint,
      bronzePoint: settingData.bronzePoint,
      silverPoint: settingData.silverPoint,
      goldPoint: settingData.goldPoint,
    })
  }, [isLoading]);


  const handleSubmit = async () => {


    setLoadingEffect(true);

    const data = {
      setting,
      companyId,
    }


    let res = await api.post(`/setting/edit`, data)
    if (res.data.status) {
      toast.success(res.data.message);
      const dataArray = ['setting']
      await refData(dataArray, companyId);
    }
    else {
      toast.error(res.data.message);
    }
    setLoadingEffect(false);
  }


  const handleChange = (name, value) => {
    setSetting((prev) => ({
      ...prev,
      [name]: value,
    }));
  }
  const handleInputChange = (e) => {
    const { name, value, type } = e.target;

    setSetting((prev) => ({
      ...prev,
      [name]: type === 'number' ? parseFloat(value) || 0 : value,
    }));
  }


  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

      <Spin spinning={loadingEffect} fullscreen />

      {isLoading &&
        <Loader />
      }

      {!isLoading &&
        <Card style={{ width: '600px' }}>

          <Row className="mb-5">
            <Col md={4}>
              <Form.Label>Point To Currency</Form.Label>
            </Col>
            <Col md={5}>
              <InputGroup>
                <Form.Control
                  type="number"
                  name="pointToCurrency"
                  onChange={handleInputChange}
                  value={setting.pointToCurrency}

                />
              </InputGroup>
            </Col>
            <Col>

            </Col>
          </Row>


          <Row className="mb-1">
            <Col md={4}>
              <Form.Label>Normal Customer</Form.Label>
            </Col>
            <Col md={5}>
              <InputGroup>
                <Form.Control
                  type="number"
                  name="normalCustomer"
                  onChange={handleInputChange}
                  value={setting.normalCustomer}

                />
              </InputGroup>
            </Col>
            <Col>

            </Col>
          </Row>

          <Row className="mb-1">
            <Col md={4}>
              <Form.Label>Bronze Customer</Form.Label>
            </Col>
            <Col md={5}>
              <InputGroup>
                <Form.Control
                  type="number"
                  name="bronzeCustomer"
                  onChange={handleInputChange}
                  value={setting.bronzeCustomer}

                />
              </InputGroup>
            </Col>
            <Col>

            </Col>
          </Row>


          <Row className="mb-1">
            <Col md={4}>
              <Form.Label>Silver Customer</Form.Label>
            </Col>
            <Col md={5}>
              <InputGroup>
                <Form.Control
                  type="number"
                  name="silverCustomer"
                  onChange={handleInputChange}
                  value={setting.silverCustomer}

                />
              </InputGroup>
            </Col>
            <Col>

            </Col>
          </Row>


          <Row className="mb-5">
            <Col md={4}>
              <Form.Label>Gold Customer</Form.Label>
            </Col>
            <Col md={5}>
              <InputGroup>
                <Form.Control
                  type="number"
                  name="goldCustomer"
                  onChange={handleInputChange}
                  value={setting.goldCustomer}

                />
              </InputGroup>
            </Col>
            <Col>

            </Col>
          </Row>



          <Row className="mb-1">
            <Col md={4}>
              <Form.Label>Normal Point</Form.Label>
            </Col>
            <Col md={5}>
              <InputGroup>
                <Form.Control
                  type="number"
                  name="normalPoint"
                  onChange={handleInputChange}
                  value={setting.normalPoint}

                />
              </InputGroup>
            </Col>
            <Col>

            </Col>
          </Row>

          <Row className="mb-1">
            <Col md={4}>
              <Form.Label>Bronze Points</Form.Label>
            </Col>
            <Col md={5}>
              <InputGroup>
                <Form.Control
                  type="number"
                  name="bronzePoint"
                  onChange={handleInputChange}
                  value={setting.bronzePoint}

                />
              </InputGroup>
            </Col>
            <Col>

            </Col>
          </Row>


          <Row className="mb-1">
            <Col md={4}>
              <Form.Label>Silver Point</Form.Label>
            </Col>
            <Col md={5}>
              <InputGroup>
                <Form.Control
                  type="number"
                  name="silverPoint"
                  onChange={handleInputChange}
                  value={setting.silverPoint}

                />
              </InputGroup>
            </Col>
            <Col>

            </Col>
          </Row>


          <Row className="mb-5">
            <Col md={4}>
              <Form.Label>Gold Point</Form.Label>
            </Col>
            <Col md={5}>
              <InputGroup>
                <Form.Control
                  type="number"
                  name="goldPoint"
                  onChange={handleInputChange}
                  value={setting.goldPoint}

                />
              </InputGroup>
            </Col>
            <Col>

            </Col>
          </Row>



          <Row>
            <Col md={5}>
            </Col>
            <Col md={6}>
              <Button style={{ backgroundColor: '#23576a', color: 'white' }} onClick={handleSubmit}>{contentLanguages.Save}</Button>
            </Col>
          </Row>



        </Card >
      }

    </div >


  )
}

export default Loayalty;
